var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.level)?_c('b-tag',{attrs:{"type":("is-" + _vm.level + " is-light"),"size":"is-small","rounded":""}},[_vm._v("\n  🧩 Level "+_vm._s(_vm.PUZZLE_COLOR_LEVELS[_vm.level])+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }